
import React, { PureComponent } from 'react';
import { pick } from 'ramda';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TeeTimeTile from './TeeTimeTile';
import preProcessTeeTime from '../../lib/preProccessTeeTime';




class TeeSheet extends PureComponent {
    static propTypes = {
        classes: PropTypes.object,
        teetimes: PropTypes.array,
        handleTeetimeSelection: PropTypes.func,
        title: PropTypes.string,
        bookingInfoMain: PropTypes.string,
        bookingInfoSecondary: PropTypes.string
    }
    render() {
        const {
            classes,
            bookingInfoMain,
            bookingInfoSecondary,
            noTeeTimesMessageMain,
            noTeeTimesMessageSecondary,
            title,
            teetimes,
            handleTeetimeSelection,
            selectedTeeTime,
            fetchingReservation
        } = this.props;
        const isMobile = isWidthDown('xs', this.props.width, true)
        return (
            <div>
                <Card className={classes.card} elevation={0}>
                    <CardHeader className={classes.header}
                        title={
                            !isMobile ? <div className={classes.inline}>
                            {title}
                        </div>
                        : [
                            <div key={0} className={classes.inline}>
                                    {title}
                            </div>,

                            <div key={1} className={classes.inlineMobile}>
                                    {bookingInfoMain + ' ' + bookingInfoSecondary}
                            </div>
                        ]
                        }
                        subheader={
                            !isMobile ? <div className={classes.inlineRight}>
                            <span className={classes.booking}>{bookingInfoMain}</span> <br/>
                            {bookingInfoSecondary}
                        </div>
                        : null

                        }
                    />
                    <CardContent className={classes.noPadding}>
                        {
                            teetimes.length > 0 ?
                                teetimes.map(
                                    teetime => {
                                        const formattedTeeTime = preProcessTeeTime(teetime);
                                        const payload = pick(
                                            ['time', 'golfersFormatted', 'holes', 'price', 'totalPrice', 'transportation', 'onSale', 'id', 'originalPrice', 'transactionFeesPrice'],
                                            formattedTeeTime
                                        )
                                        return (
                                            <TeeTimeTile
                                                key={formattedTeeTime.id}
                                                { ...payload }
                                                booking={formattedTeeTime.id === selectedTeeTime && fetchingReservation}
                                                onBook={handleTeetimeSelection}
                                            />
                                        );
                                    }
                                ) : <div className={classes.noTeeTimesRoot}>
                                    {noTeeTimesMessageMain + ' ' +  noTeeTimesMessageSecondary}
                                </div>
                        }
                    </CardContent>

                </Card>
            </div>
        );
    }
}

const styles = (theme) => ({
    mainColor: {
        color: 'red'
    },
    card: {
        marginBottom: '20px',
        border: '1px solid #d5d8db',
        [theme.breakpoints.down('sm')]: {
            borderTop: 'none',
            marginBottom: 0,
            borderRadius: 0
        }
    },
    header: {
        backgroundColor: theme.palette.secondary.main,
        padding: '10px 25px',
        [theme.breakpoints.down('sm')]: {
           paddingLeft: 10,
           paddingTop: 0,
           paddingBottom: 0
        },
        borderBottom: '1px solid #d5d8db'
    },
    padding: {
        padding: '20px'
    },
    inline: {
        float: 'left',
        fontSize: '18px',
        marginTop: '5px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px',
            height: '22px'
        }
    },
    inlineMobile: {
        float: 'left',
        fontSize: 12,
        color: '#75787B'
    },
    inlineRight: {
        fontSize: '13px',
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            fontSize: '11px'
        }
    },
    noTeeTimesRoot: {
        textAlign: 'left',
        flexGrow: 1,
        color: '#A5A8AB',
        fontFamily: theme.typography.fontFamily,
        margin: '25px',
        fontSize: '13px'
    },
    MuiCardHeader: {
        subheader: {
            float: 'right'
        }
    },
    noPadding: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    booking: {
        [theme.breakpoints.down('sm')]: {
            fontWeight: 'bold',
            color: theme.palette.common.black
        }
    },
    noTeeTimes: {
        fontWeight: 'bolder',
        fontSize: '13px',
        color: '#A5A8AB'
    }
});

export default withWidth()(withStyles(styles)(TeeSheet));



// WEBPACK FOOTER //
// ./src/components/TeeSheet/index.js